<script setup>
defineProps({
    // Empty while categories are parked for launch (GH-1252): the navy band
    // still renders (it is the hero card's seam) but holds no controls.
    tabs: {
        type: Array,
        default: () => [],
    },
    modelValue: {
        type: String,
        default: null,
    },
});

defineEmits(["update:modelValue"]);

// Red downward triangle used as the mobile select's only dropdown indicator
// (matches ExpertListsSection's mobile category select).
const selectCaret = `url("data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20width='14'%20height='10'%20viewBox='0%200%2014%2010'%3E%3Cpath%20fill='%23f21439'%20d='M7%2010%200%200h14z'/%3E%3C/svg%3E")`;
</script>

<template>
    <section
        class="bg-brand-navy px-4 sm:px-9 md:py-0 xl:px-[84px]"
        :class="tabs.length ? 'py-5' : 'py-2.5'"
    >
        <!-- Without tabs the strip stays as the hero seam at half height. -->
        <div
            class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between md:gap-8"
            :class="tabs.length ? 'md:h-[90px]' : 'md:h-[45px]'"
        >
            <template v-if="tabs.length">
                <h2
                    class="font-brand text-[22px] font-semibold text-white md:text-[28px]"
                >
                    I&rsquo;m looking for gifts for&hellip;
                </h2>

                <!-- Mobile: category dropdown -->
                <div class="relative md:hidden">
                    <select
                        :value="modelValue"
                        :style="{ backgroundImage: selectCaret }"
                        class="h-11 w-full appearance-none rounded-brand border-0 bg-white bg-[position:right_1rem_center] bg-[length:12px_9px] bg-no-repeat pl-4 pr-10 font-brand text-[15px] font-semibold text-brand-navy [-moz-appearance:none] [-webkit-appearance:none]"
                        @change="
                            $emit('update:modelValue', $event.target.value)
                        "
                    >
                        <option v-for="tab in tabs" :key="tab" :value="tab">
                            {{ tab }}
                        </option>
                    </select>
                </div>

                <!-- Desktop: inline tabs with the gold active underline -->
                <ul
                    class="flex-wrap items-center gap-x-11 gap-y-3 font-brand-display text-[14px] font-semibold uppercase tracking-wide max-md:hidden md:flex"
                >
                    <li v-for="tab in tabs" :key="tab">
                        <button
                            type="button"
                            class="pb-2 transition"
                            :class="
                                modelValue === tab
                                    ? 'text-white shadow-[0_2px_0_0_#ffc003]'
                                    : 'text-white/60 hover:text-white'
                            "
                            @click="$emit('update:modelValue', tab)"
                        >
                            {{ tab }}
                        </button>
                    </li>
                </ul>
            </template>
        </div>
    </section>
</template>
